import { render, staticRenderFns } from "./PicNews.vue?vue&type=template&id=45e7abb9&scoped=true"
import script from "./PicNews.vue?vue&type=script&lang=js"
export * from "./PicNews.vue?vue&type=script&lang=js"
import style0 from "./PicNews.vue?vue&type=style&index=0&id=45e7abb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e7abb9",
  null
  
)

export default component.exports